// extracted by mini-css-extract-plugin
module.exports = {"deviceBox":"device_deviceBox__3OvAA","deviceLink":"device_deviceLink__G9CAO","deviceImg":"device_deviceImg__3jdo4","title":"device_title__2OcEm"};